<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		:title="m.id == 0 ? '数据增加' : '数据修改'"
		:visible.sync="isShow"
		width="400px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="编号：" v-show="m.id!=0">
						<el-input v-model="m.id" disabled></el-input>
					</el-form-item>
					<el-form-item label="名称：">
						<el-input v-model="m.name"></el-input>
					</el-form-item>
          <el-form-item label="课程：" v-if="m.id==0">
            <el-select size="mini" v-model="m.subId">
              <el-option v-for="sub in subList" :label="sub.name" :value="sub.id" :key="sub.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总课时：" v-if="m.id==0">
            <el-input v-model="m.hour"></el-input>
          </el-form-item>
          <el-form-item label="带班老师：">
            <el-select size="mini" v-model="m.teaId">
              <el-option v-for="tea in teacherList" :label="tea.name" :value="tea.id" :key="tea.id"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="季度：">
            <el-select size="mini" v-model="m.quarter">
              <el-option v-for="q in quarterList" :label="q.name" :value="q.id" :key="q.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区：">
            <el-select size="mini" v-model="m.campus">
              <el-option v-for="c in campusList" :label="c.name" :value="c.id" :key="c.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送：" v-if="m.id!=0">
            <el-switch
                v-model="m.push"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="开启"
                inactive-text="关闭"
                active-value="0"
                inactive-value="1">
            </el-switch>
          </el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: true,
				id: 0,
				m: null,
        subList:[],
        teacherList:[],
        campusList:[],
        quarterList:[{id:1,name:'春季'},
          {id:2,name:'暑假'},
          {id:3,name:'秋季'},
          {id:4,name:'寒假'},
        ],

			}
		},
		methods: {
      getSubList:function (){
        this.sa.ajax('api/psdAdmin/subject/getList',
            {},
            function(res){
              this.subList = res.data;
              console.log('科目',res.data);
            }.bind(this),{async:false});
      },
      getTeacherList:function (){
        this.sa.ajax('api/psdAdmin/teacher/getList',
            {},
            function(res){
              this.teacherList = res.data;
              console.log('老师',res.data);
            }.bind(this),{async:false});
      },
      getCampusList:function (){
        this.sa.ajax('api/psdAdmin/campus/getList',
            {},
            function(res){
              this.campusList = res.data;
              console.log('校区',res.data);
            }.bind(this),{async:false});
      },
			// 打开
			open: function(id) {

				// this.id = id;
				this.isShow = true;
				if(id == 0){	// 如果是添加
					this.m = this.create_m();
				} else {
					//id 非 0 代表 是要修改 先查询一下，把旧值显示在input中
					this.sa.ajax('api/psdAdmin/clazz/getClazzInfoById', {id: id}, function(res) {
						this.m = res.data;
            this.m.teaId = parseInt(this.m.teaId);
            this.m.quarter = parseInt(this.m.quarter);
						console.log(res.data);
					}.bind(this), /*{res: this.getMockData(id)}*/);
				}
			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.name)) {
					return sa.error('请输入班级名称');
				}
				if(m.id == 0 && sa.isNull(m.subId)) {
					return sa.error('请输入所属科目');
				}
        if(m.id == 0 && sa.isNull(m.hour)) {
          return sa.error('请输入总课时');
        }
        if(sa.isNull(m.teaId)) {
          return sa.error('请选择带班老师');
        }
        if(sa.isNull(m.quarter)) {
          return sa.error('请选择所属季度');
        }
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				// 开始增加或修改
				let self = this;
				if(this.m.id == 0) {
					// id == 0 为增加
          console.log(this.m);
					this.sa.ajax('api/psdAdmin/clazz/addClazzInfo', JSON.stringify(this.m), function(res) {
					  if(res.code == '0'){
              self.sa.alert('增加成功', function() {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '新增失败');
            }

					},{ contentType:"application/json;charset=UTF-8"});
				} else {
					// id != 0 为修改
					this.sa.ajax('api/psdAdmin/clazz/updateClazzInfo', JSON.stringify(this.m), function(res){
            if(res.code == '0') {
              self.sa.alert('修改成功', function () {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '修改失败');
            }
					},{ contentType:"application/json;charset=UTF-8"});
				}
			},
			// 创建一个空的model
			create_m: function() {
				return {
					id: 0,
					name: '',
          subId:'',
          hour:'',
          teaId:'',
          campus:'',
				}
			},
		},
		created: function(){
			this.getSubList();
			this.getTeacherList();
			this.getCampusList();
		}
	}
</script>
